import { useTranslation } from '@/i18n';
import { FileOption } from '@moneyforward/ap-frontend-components/dist/es/molecules/FileList/type';
import { useMemo } from 'react';

export const useFileOptions = (
  handleOptionChecked: FileOption['onChange'],
  showAiSuggest = false
) => {
  const { t } = useTranslation();
  const options = useMemo((): TFileOption[] => {
    const opts: TFileOption[] = [
      {
        label: t('received_invoice.uploader.ai_ocr'),
        name: 'do_ai_ocr',
        tooltip: t('received_invoice.uploader.ai_ocr_tooltip'),
        onChange: handleOptionChecked,
        defaultChecked: true,
      },
    ];
    if (showAiSuggest) {
      opts.push({
        label: t('received_invoice.uploader.ai_suggest'),
        name: 'do_ai_suggest',
        tooltip: t('received_invoice.uploader.ai_suggest_tooltip'),
        onChange: handleOptionChecked,
        defaultChecked: false,
      });
    }
    return opts;
  }, [t, handleOptionChecked, showAiSuggest]);
  return options;
};

export type TFileOption = FileOption & { defaultChecked?: boolean };
